function Heading(props) {
  let classNames = `${props.className} tw-text-center`;
  let headlineClassNames = props.headlineClassNames;
  let headerStyle ={wordBreak:'keep-all'};
  return (
    <div className={classNames}>
      <h2 style={headerStyle} className={"tw-tracking-tight tw-text-teal tw-font-normal tw-text-3xl tw-uppercase tw-leading-3 tw-mt-4 "+headlineClassNames}>
        {props.title}
      </h2>
      {props.subtitle && (
        <p style={headerStyle} className="tw-font-black tw-font-italic tw-text-md tw-uppercase tw-leading-4 tw-mt-2">
          {props.subtitle}
        </p>
      )}
    </div>
  );
}

export default Heading;
